import * as React from 'react';
import * as PropTypes from 'prop-types';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/settings.css';

import { Field, reduxForm, FormProps, InjectedFormProps } from 'redux-form';

interface ForgotPasswordProps extends FormProps<InjectedFormProps, {}> {
  headerActions?: any;
  password: any;
  forgotPasswordForm: any;
  passwordActions: any;
  dialogActions?: any;
}

class ForgotPasswordForm extends React.Component<ForgotPasswordProps, {}> {
  static propTypes = {
    password: PropTypes.any.isRequired,
    passwordActions: PropTypes.any.isRequired,
  };

  private focusForm: any;

  componentDidmount() {
    this.focusForm.getRenderedComponment().focus();
  }

  handleChangeUsername(event: any) {
    // do nothing
  }

  handleSubmit(event: React.FormEvent<HTMLInputElement|HTMLFormElement>) {
    event.preventDefault();
    if (typeof(this.props.forgotPasswordForm) === 'undefined') {
      return;
    }

    // undefinedになってた時に最低から文字にしてcognite側で判断させる
    const username = this.props.forgotPasswordForm.username || '';

    this.props.passwordActions.forgotPassword(
      username,
      (res: any, message: string) => {
        if (res === false) {
          alert(message);
        }
      }
    );
  }

  render() {
    return (
      <div>
        <div id="procedure1" className="forgotPassword">
          <h2>パスワードを忘れた方</h2>
          <form>
            <div id="messageProcedure1" className="alert" style={{display: 'none'}} />
            <table className="changePasswordForm">
              <tr>
                <th>事業所ID</th>
                <td>
                  <Field
                    id="inputUsername"
                    name="username"
                    type="text"
                    component="input"
                    placeholder="事業所ID"
                    required={true}
                    autoFocus={true}
                    ref={(input: any) => { this.focusForm = input; }}
                    onChange={(e) => this.handleChangeUsername(e)}
                  />
                </td>
              </tr>
              <tr>
                <th>&nbsp;</th>
                <td>
                  <input
                    id="forgotPasswordButton"
                    type="button"
                    className="btnStyle01"
                    value="再発行手続きをする"
                    onClick={(event) => this.handleSubmit(event)}
                  />
                </td>
              </tr>
            </table>
          </form>
        </div>
        <div id="procedureDescription">
          <p>パスワードを紛失した場合は、今までのパスワードをお問い合わせいただくのではなく、再発行する手続きを取っていただく必要があります。</p>
          <p>再発行手続きは、事業所IDを入力して「再発行手続きする」ボタンをクリックして下さい。</p>
          <p>&nbsp;</p>
          <p>ボタンをクリックして、パスワードの再発行手続きが開始されると、</p>
          <ul>
            <li>1. ご契約時のメールアドレス宛てにメールが届きます。</li>
            <li>2. メールに「認証コード」が記載されているのを確認します。</li>
            <li>3. メールに記載されているURLをクリック(もしくはWebブラウザにコピー＆ペースト)してパスワード再発行ページを開きます。</li>
            <li>4. 開いたWebページに記載されている内容を読んで、手続きを行って下さい。</li>
            <li>以上の手続きで、新しいパスワードの再発行手続きが行なえます。</li>
          </ul>
          <p>&nbsp;</p>
          <p>※メールは、ご契約情報として登録がされているメールアドレスに送信されます。</p>
          <p>ご契約情報として登録がされているメールアドレスに送信されます。もしお届けのメールアドレスに届いていない場合は、担当営業にお問い合わせください。</p>
          <p>&nbsp;</p>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'forgotPasswordForm'
})(ForgotPasswordForm as any);



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordForm.tsx